export const colorConstants = {
    background: 'rgb(240, 240, 240)',
}